import React, { useEffect, useRef, useState } from "react";
import TextfieldNumber from "../textfields/textfield.number";
import { styles } from "../../stylesheets/simulateurs.css";
import "../../stylesheets/simulateursBis.css";
import SelectCommon from "../selects/select.common";
import ButtonYesno from "../buttons/button.yesno.js";
import { useDispatch } from "react-redux";
import { setDMTGObject } from "../../actions/dmtg.action";
import { ToolTipPerso } from "../selects/tooltip_perso";
import TextfieldAbattement from "../textfields/textfield.abattement";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import TextField from "@mui/material/TextField";
import moment from "moment";
import { useSnackbar } from "notistack";
import Souche from "./souche";
import axios from "axios";
import {API_BASE_URL} from "../../config";

const Successions_Donataire = (props) => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const setInReduxRef = useRef(null);
  const [lien_parente_succession, setLien] = useState(1);
  const [conditions_particulieres, setConditions] = useState(0);
  const [handicap, setHandicap] = useState(0);
  //MONTANT G
  const [montant_succession, setMontantSuccesion] = useState(0);
  const [abattement_legal_base, setAbattementLegalBase] = useState(0);
  const [abattement_legal, setAbattementLegal] = useState(0);
  const [montant_utilise, setMontantUtilise] = useState(0);
  const [abattementReconstitue, setAbattementReconstitue] = useState(0);
  const [donationsAnterieures, setDonationsAnterieures] = useState(0);
  const [donationsData, setDonationsData] = useState([{}]);
  //MONTANT F
  const [montant_rapportable, setRapportable] = useState(0);
  const [total_succession, setTotalSuccession] = useState(props.total_succession || 0);
  const [montant_article757b, setMontantArticle757b] = useState(0);
  const [enRepresentation, setEnRepresentation] = useState(0);
  const [enRepresentationResetKey, setEnRepresentationResetKey] = useState(0);
  const [representants, setRepresentants] = useState(0);
  const [representantsList, setRepresentantsList] = useState([]);
  let rappelFiscal;
  const [abattements, setAbattements] = useState([]);   // ex-back: [{cas, abattement_legal, taux_tranche}, ...]
  const BONUS_HANDICAP = 159_325;
  const formatNumber = (n) => new Intl.NumberFormat("fr-FR").format(Number(n || 0));
  const canUseRepresentation = (lien) => [2, 3].includes(Number(lien));


  useEffect(() => {
    if (props.total_succession !== undefined && props.total_succession !== null) {
      setTotalSuccession(props.total_succession);
    }
  }, [props.total_succession]);

  useEffect(() => {
    setInRedux(null, null); // Init le redux
  }, [props.simulateurid]);

  // useEffect pour calculer montant_succession chaque fois que montant_rapportable, total_succession ou donataires changent
  useEffect(() => {
    const newMontantSuccession = Math.ceil(
      (props.total_succession || 0) / (props.donataires || 0) - (montant_rapportable || 0)
    );
    setMontantSuccesion(newMontantSuccession);
    handleChange(setMontantSuccesion, newMontantSuccession);
  }, [montant_rapportable, props.total_succession, props.donataires]);

  useEffect(() => {
    if (enRepresentation === 1) {
      setRepresentants(1);
    } else {
      setRepresentants(0);
      setRepresentantsList([]);
      setInRedux(setRepresentantsList, []);
    }
  }, [enRepresentation]);

  useEffect(() => {
    if (enRepresentation === 1 && representants > 0) {
      if (representantsList.length < representants) {
        let updated = [...representantsList];
        for (let i = representantsList.length; i < representants; i++) {
          updated.push({ handicap: 0, beneficiaire_assurance_vie: 0, representant_index: i + 1 });
        }
        setRepresentantsList(updated);
        setInRedux(setRepresentantsList, updated);
      } else if (representantsList.length > representants) {
        let updated = representantsList.slice(0, representants);
        setRepresentantsList(updated);
        setInRedux(setRepresentantsList, updated);
      } else {
        setInRedux(setRepresentantsList, representantsList);
      }
    } else {
      setRepresentantsList([]);
      setInRedux(setRepresentantsList, []);
    }
  }, [representants, enRepresentation]);

  useEffect(() => {
    if (donationsData && donationsData.length > 0) {
      const newAbattementUtilise = donationsData.reduce((sum, donation) => {
        return sum + (donation.montant || 0);
      }, 0);
      handleChange(setMontantUtilise, newAbattementUtilise)
    }
  }, [donationsData, abattement_legal, abattementReconstitue]);

  const handleChange = async (setter, value) => {
    // On ne modifie que la variable pertinente
    if (setter === setLien && !canUseRepresentation(value)) {
      setEnRepresentation(0);
      setRepresentants(0);
      setRepresentantsList([]);
    }
    if (setter === setEnRepresentation && parseInt(value) !== 1) {
      setRepresentants(0);
      setRepresentantsList([]);
    }
    if (setter === setEnRepresentation && parseInt(value) === 1) {
      if (Number(props.donataires) === 1 && Number(lien_parente_succession) === 2) {
        enqueueSnackbar(<span>Les <b><u>neveux et nièces</u></b> venant à la succession d’un <b><u>frère ou sœur unique</u></b> prédécédé ne bénéficient pas de la représentation fiscale.</span>, {
          variant: "warning",
        });
        setEnRepresentationResetKey((k) => k + 1);
        return;
      }
      setHandicap(0);
    }
    if (setter === setRepresentants && value >= 9) {
      enqueueSnackbar('Le nombre de representants ne peut dépasser 9', {
          variant: 'warning'
        });
    }
    if (setter === setRapportable) {
      value = Number(value) || 0;
      const totalRapportableRenseigne =
        props.total_rapportable !== undefined && props.total_rapportable !== null;
      if (Number(value) > 0 && !totalRapportableRenseigne) {
        enqueueSnackbar('Veuillez remplir d\'abord le montant rapportable total', {
          variant: 'warning'
        });
        return;
      } else if (Number(value) > Number(props.total_rapportable || 0)) {
        enqueueSnackbar('Veuillez saisir un montant égal ou inférieur au montant rapportable total', {
          variant: 'warning'
        });
        return;
      }
    }
    if (setter === setMontantUtilise) {
      value = Math.max(Math.min(parseInt(value) || 0, abattement_legal) - (parseInt(abattementReconstitue) || 0), 0);
    }
    if (setter === setAbattementReconstitue) {
      if (parseInt(value) >= (parseInt(abattement_legal) || 0)) {
        enqueueSnackbar("Le montant de l'abattement reconstitué ne peut pas dépasser le montant de l'abattement légal", { 
          variant: 'warning' 
        });
      }
      value = Math.min((parseInt(value) || 0), (parseInt(abattement_legal) || 0))
    }
    setter(value);
    setInRedux(setter, value);
  };

  const handleMontantRapportableCapture = (e) => {
    const value = Number(e.target.value.replace(/\D/g, '')) || 0;
    const totalRapportableRenseigne =
      props.total_rapportable !== undefined && props.total_rapportable !== null;
    const maximum = Number(props.total_rapportable) || 0;

    if (value > maximum) {
      enqueueSnackbar(
        totalRapportableRenseigne
          ? 'Veuillez saisir un montant égal ou inférieur au montant rapportable total'
          : "Veuillez remplir d'abord le montant rapportable total",
        { variant: 'warning' }
      );
    }
  };

  const handleDonationChange = async (index, key, value) => {
    if (key === "date") {
      rappelFiscal = new Date(props.dateDonation);
      rappelFiscal.setFullYear(rappelFiscal.getFullYear() - 15);
      if (index === 0) {
        if (value > props.dateDonation) {
          enqueueSnackbar("La date doit être antèrieure à celle de la nouvelle donation", {
            variant: "error",
          });
          return;
        } else {
          props.setLastDonationDate(value)
        }
      } else {
        if (value > donationsData[index - 1]["date"]) {
          enqueueSnackbar("La date doit être antèrieure à celle de la donation précédente", {
            variant: "error",
          });
          return;
        }
      }
      if (value < parseInt(moment(rappelFiscal.toString()).utc(true).format("x"))) {
        enqueueSnackbar("La date est en dehors du rappel fiscal", {
          variant: "error",
        });
        return;
      } else if (donationsData.length - 1 === index) {
        props.setFirstDonationDate(value);
      }
    }
    if (key === "montant") {
      value= parseFloat(value)
    };
    if (key === "droits_regles") {
      value= parseFloat(value)
    };
    const updatedDonations = [...donationsData];
    updatedDonations[index][key] = value;
    setDonationsData(updatedDonations);
    setInRedux(setDonationsData, updatedDonations);
  };

  const addDonation = () => {
    if (!donationsData[donationsData.length - 1]["date"] || !donationsData[donationsData.length - 1]["montant"]) {
      enqueueSnackbar("Merci de remplir les informations de la donation antèrieure avant d'en rajouter une autre", {
        variant: "error",
      });
      return;
    }
    const updatedDonations = [...donationsData, {}];
    setDonationsData(updatedDonations);
  };

  const removeDonation = () => {
    if (donationsData.length > 1) {
      const updatedDonations = [...donationsData];
      updatedDonations.pop();
      setDonationsData(updatedDonations);
      setInRedux(setDonationsData, updatedDonations);
    }
  };

  const montantRevenantHeritier = props.donataires > 0 ? Math.round(props.total_succession / props.donataires) : 0;
  const nombreRepresentants = Math.max(parseInt(representants) || 0, 0);
  const montantRepresentant = nombreRepresentants > 0
    ? Math.round((montant_succession || 0) / nombreRepresentants)
    : 0;
  const abattementLegalRestant = Math.max((abattement_legal_base || 0) - (montant_utilise || 0), 0);
  const abattementLegalRepresentant = nombreRepresentants > 0
    ? Math.round(abattementLegalRestant / nombreRepresentants)
    : 0;
  const isDroitsReglesEnabled = (donations = donationsData) => {
    const abattementUtilise = donations.reduce((sum, donation) => sum + (Number(donation.montant) || 0), 0);
    return abattementUtilise < Number(abattement_legal_base || 0);
  };
  const isAbattementReconstitueEnabled = (donations = donationsData) =>
    donations.some((donation) => Number(donation.montant || 0) > 0) && !isDroitsReglesEnabled(donations);
  const formatDonationsData = (donations = donationsData) =>
    donations.map(({ montant, date, droits_regles }) => ({
      montant: parseFloat(montant),
      date,
      droits_regles: isDroitsReglesEnabled(donations) ? parseFloat(droits_regles || 0) : 0,
    }));

  const FunctionSetRepresentantsList = (key, value) => {
    const updated = [...representantsList];
    updated[key] = value;
    setRepresentantsList(updated);
    setInRedux(setRepresentantsList, updated);
  };

  const FunctionSetAllRepresentantsList = (key, value) => {
    const updated = [...representantsList];
    updated[key] = value;
    setRepresentantsList(updated);
    setInRedux(setRepresentantsList, updated);
  };

  function setInRedux(setter, value) {
    const estRepresenteValue =
      setter === setEnRepresentation ? parseInt(value) : parseInt(enRepresentation);
    const nombreRepresentantsValue =
      setter === setRepresentants ? parseInt(value) : parseInt(representants);
    let object = {
      simulateurid: props.simulateurid,
      inputs: {
        montantRevenantHeritier: montantRevenantHeritier,
        lien_parente_succession: parseInt(lien_parente_succession),
        conditions_particulieres: parseInt(conditions_particulieres),
        handicap: estRepresenteValue === 1 ? 0 : parseInt(handicap),
        montant_succession: parseInt(montant_succession),
        montant_utilise: parseInt(montant_utilise),
        abattement_reconstitue: parseInt(abattementReconstitue),
        montant_rapportable: parseInt(montant_rapportable),
        total_succession: parseInt(props.total_succession),
        donateur: parseInt(props.donateur),
        donataire: parseInt(props.soloResultKey + 1),
        montant_article757b: parseInt(montant_article757b),
        est_represente: estRepresenteValue,
      },
      donations_anterieures: donationsData.map(({ montant, date, droits_regles}) => ({
        montant: parseFloat(montant),
        date: Date.parse(date),
        droits_regles: parseFloat(droits_regles || 0)
      }))
    };
    if (estRepresenteValue === 1) {
      Object.assign(object["inputs"], { nombre_representants: nombreRepresentantsValue });
    }

    //WRONG ? but still here just in case
    // if (donationsData[0].date != null) {
    //   Object.assign(object, {
    //     donations_anterieures: donationsData.map(({ montant, date }) => ({
    //       montant: parseFloat(montant),
    //       date: Date.parse(date),
    //     })),
    //   });
    // }

    if (props.dateDonation !== undefined && props.dateDonation !== null) {
      Object.assign(object["inputs"], {
        date_nouvelle_donation: parseInt(moment(props.dateDonation.toString()).utc(true).format("x")),
      });
    }
    
    if (setter === setLien) {
      Object.assign(object["inputs"], { lien_parente_succession: parseInt(value) });
      if (!canUseRepresentation(value)) {
        Object.assign(object["inputs"], { est_represente: 0 });
        delete object["inputs"].nombre_representants;
      }
    }
    if (setter === setTotalSuccession) { Object.assign(object["inputs"], { total_succession: parseInt(value) }); }
    if (setter === setConditions) { Object.assign(object["inputs"], { conditions_particulieres: parseInt(value) }); }
    if (setter === setHandicap) { Object.assign(object["inputs"], { handicap: parseInt(value) }); }
    if (setter === setMontantSuccesion) { Object.assign(object["inputs"], { montant_succession: parseInt(value) }); }
    if (setter === setMontantUtilise) { Object.assign(object["inputs"], { montant_utilise: parseInt(value) }); }
    if (setter === setAbattementReconstitue) { Object.assign(object["inputs"], { abattement_reconstitue: parseInt(value) }); }
    if (setter === setDonationsAnterieures) {
      if (value === 0) {
        setDonationsData([{}]);
        object.donations_anterieures = [{}];
        setAbattementReconstitue(0);
        setMontantUtilise(0);
        Object.assign(object["inputs"], { montant_utilise: 0 });
      } else {
        object.donations_anterieures = formatDonationsData(donationsData);
        handleDonationChange(0, "date", Date.parse(props.dateDonation));
      }
    }
    if (setter === setDonationsData) { object.donations_anterieures = formatDonationsData(value); }
    if (setter === setRapportable) { Object.assign(object["inputs"], { montant_rapportable: parseInt(value) }); }
    if (setter === setMontantArticle757b) { Object.assign(object["inputs"], { montant_article757b: parseInt(value) }); }
    if (setter === setEnRepresentation) {
      Object.assign(object["inputs"], { est_represente: parseInt(value) });
      if (parseInt(value) === 1) {
        Object.assign(object["inputs"], { handicap: 0 });
      }
      if (parseInt(value) !== 1) {
        delete object["inputs"].nombre_representants;
      }
    }
    if (setter === setRepresentants && estRepresenteValue === 1) {
      Object.assign(object["inputs"], { nombre_representants: parseInt(value) });
    }
    if (setter === setRepresentantsList && estRepresenteValue === 1) {
      object.representants = value;
    } else if (estRepresenteValue === 1) {
      object.representants = representantsList;
    }

    props.functionSetSoloResults(props.soloResultKey, object);
    dispatch(setDMTGObject(object));
  }

  setInReduxRef.current = setInRedux;


  useEffect(() => {
    const controller = new AbortController();
    const token = JSON.parse(localStorage.getItem("user"))?.jwt;

    axios.get(`${API_BASE_URL}/abattement_DMTG`, {
      signal: controller.signal,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    })
    .then((res) => {
      // normalise
      const rows = (res.data ?? []).map(r => ({
        id: Number(r.id),
        cas: Number(r.cas),
        description: String(r.description),
        abattement_legal: Number(r.abattement_legal),
      }));
      const successionsAbattements = rows
        .filter(r => r.id >= 1 && r.id <= 6)
        .sort((a, b) => a.cas - b.cas);

      setAbattements(successionsAbattements);

      if (successionsAbattements.length > 0) {
        const firstCas = successionsAbattements[0].cas;
        setLien(firstCas);
        setInReduxRef.current(setLien, firstCas);
      }
    })
    .catch((err) => {
      console.error("GET /abattement_DMTG failed:", err?.response?.status, err?.response?.data);
      enqueueSnackbar("Erreur chargement abattements", { variant: "error" });
    });

    return () => controller.abort();
  }, []);


  useEffect(() => {
    if (!lien_parente_succession) return;

    const selected = abattements.find(r => r.cas === Number(lien_parente_succession));
    if (!selected) return;

    setAbattementLegalBase(selected.abattement_legal);

    let value = selected.abattement_legal;
    if (Number(handicap) === 1 && Number(enRepresentation) !== 1) value += BONUS_HANDICAP;

    setAbattementLegal(value);
  }, [lien_parente_succession, handicap, enRepresentation, abattements]);


  return (
    <div style={styles.cardFlexContainer}>

      <div style={styles.cardTitleDonataire}>{enRepresentation ? ("Souche") : ("Héritier")} {props.soloResultKey + 1}</div>

      <div className="cardRow">
        <div style={styles.cardElemVerticalyCenter}>Quel est leur lien de parenté ?</div>
        {abattements.length > 0 && (
          <SelectCommon
            items={abattements}
            nameField="description"
            optionValue="cas"
            defaultValue={lien_parente_succession || abattements[0].cas}
            handleChange={handleChange}
            setter={setLien}
          />
        )}
      </div>

      {parseInt(lien_parente_succession) === 2 ? (
        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>
            Conditions particulières ?
            <ToolTipPerso
              title={
                "Être célibataire, veuf, divorcé ou séparé de corps et à la double condition : \n" +
                " - d’être âgé de plus de cinquante ans ou infirme \n" +
                " - et avoir été domicilié constamment chez le défunt pendant les 5 années qui ont précédé le décès."
              }
            />
          </div>
          <ButtonYesno handleChange={handleChange} setter={setConditions} defaultValue={0} />
        </div>
      ) : (
        <></>
      )}

      {parseInt(lien_parente_succession) === 2 && parseInt(conditions_particulieres) === 1 ? (
        <div>
          <div style={styles.messageInABottle}>Le ou les bénéficaires sont exonérés de droits</div>
        </div>
      ) : (
        <></>
      )}

      {parseInt(enRepresentation) !== 1 ? (
        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>
            Le bénéficiaire est-il en situation de handicap ?
            <ToolTipPerso
              title={
                "Cas de l’héritier incapable de travailler dans des conditions normales de rentabilité, en raison d'une infirmité physique ou mentale, congénitale ou acquise (CGI, art. 779, BOI-ENR-DMTG-10-50-20, § 120 à 190)."
              }
            />
          </div>
          <ButtonYesno handleChange={handleChange} setter={setHandicap} defaultValue={0} />
        </div>
      ) : (
        <></>
      )}

      {canUseRepresentation(lien_parente_succession) ? (
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>
              L'héritier est-il représenté (en raison de son prédécès ou de sa renonciation) ?
              <ToolTipPerso
                  title={
                    `La représentation a lieu à l'infini dans la ligne directe descendante. En ligne collatérale, la représentation est admise en faveur des enfants et descendants des frères ou sœurs du défunt (C. civ., art. 752 et 752-2).
                    ${lien_parente_succession == 3 ? "\n Les héritiers représentant leur parent à la succession de leur grand-parent n’ont pas à faire application du rappel fiscal s’agissant du tarif (Cass. com., 8 juill. 2026, n° 25-13.219)" : ""}`
                  }
              />
            </div>
            <ButtonYesno key={enRepresentationResetKey} handleChange={handleChange} setter={setEnRepresentation} defaultValue={0} />
          </div>
      ) : (
          <></>
      )}

      {parseInt(enRepresentation) === 1 ? (
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>
              Combien existe-t-il de personnes représentant l'héritier prédécédé ou renonçant ?
            </div>
            <TextfieldNumber
                handleChange={handleChange}
                type={"number"}
                defaultValue={representants}
                setter={setRepresentants}
                max={9}
            />
          </div>
      ) : (
          <></>
      )}

      <div className="cardRow" onChangeCapture={handleMontantRapportableCapture}>
        <div style={styles.cardElemVerticalyCenter}>
          Montant des donations, reçues par l'héritier, rapportables à la succession (de plus ou moins de 15 ans)
          <ToolTipPerso
            title={
              "Indiquer le montant des donations rapportables par héritier, déterminé selon les règles des articles 860 et 860-1 du Code civil. \n" +
              "Toutes les donations en avancement de part successorale hors donation-partage, donations simples notariées ou dons manuels, quel que soit le régime fiscal, consenties par le défunt de son vivant à l’héritier. \n" +
              "Le simulateur suppose que le renonçant doive le rapport en cas de renonciation."
            }
          />
        </div>
        <TextfieldNumber
          handleChange={handleChange}
          type={"number"}
          placeholder={"Indiquer le montant"}
          setter={setRapportable}
          defaultValue={montant_rapportable}
          max={Number(props.total_rapportable) || 0}
        />
      </div>

      <div className="cardRow">
        <div style={styles.cardElemVerticalyCenter}>Masse à partager avec l'ensemble des héritiers</div>
        <TextfieldAbattement
          type={"number"}
          placeholder={props.total_succession.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " €"}
        />
      </div>

      {props.donataires > 1 ? (
        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>Dont 1/{props.donataires} revenant à {enRepresentation ? ("la souche") : ("l'héritier")}</div>
          <TextfieldAbattement
            type={"number"}
            placeholder={montantRevenantHeritier.toLocaleString("en-EN").replace(/,/g, " ") + " €"}
          />
        </div>
      ) : (
        <></>
      )}

      <div className="cardRow">
        <div style={styles.cardElemVerticalyCenter}>Sous déduction du montant de son rapport</div>
        <TextfieldAbattement
          type={"number"}
          placeholder={(montant_rapportable || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " €"}
        />
      </div>

      <div className="cardRow">
        <div style={styles.cardElemVerticalyCenter}>Montant taxable revenant à {enRepresentation ? ("la souche") : ("l'héritier")}</div>
        <TextfieldAbattement
          type={"number"}
          placeholder={montant_succession.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " €"}
        />
      </div>

      <div className="cardRow">
        <div style={styles.cardElemVerticalyCenter}>
          Montant taxable au titre de l'article 757 B du CGI
          <ToolTipPerso
              title={
                "Quote-part des primes des versées sur le ou les contrats d'assurance-vie après le 70e anniversaire de l'assuré, après application du prorata d'abattement de 30 500 € applicable à l'héritier bénéficiaire."
              }
          />
        </div>
        <TextfieldNumber
            handleChange={handleChange}
            type={"number"}
            placeholder={"Indiquer le montant"}
            setter={setMontantArticle757b}
        />
      </div>

      <div className="cardRow">
        <div style={styles.cardElemVerticalyCenter}>Abattement légal</div>
        <TextfieldAbattement type={"number"} placeholder={`${formatNumber(abattement_legal)} €`} />
      </div>

      {/*DONATIONS ANTERIEURES*/}
      <div className="cardRow">
        <div style={styles.cardElemVerticalyCenter}>
          L'héritier {enRepresentation ? ("représenté ") : ("")}a-t-il reçu une donation au cours des 15 dernières années ?
          <ToolTipPerso
            title={
              "Indiquer toutes les donations consenties par le défunt de son vivant à l’héritier dans les 15 dernières années, en avancement de part successorale ou hors part successorale, donations-partages, dons manuels hors dispositifs de faveur de type don familial de somme d’argent notamment."
            }
          />
        </div>
        <ButtonYesno handleChange={handleChange} setter={setDonationsAnterieures} defaultValue={0} />
      </div>

      {donationsAnterieures ? (
        <div>
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>Part de l’abattement légal déjà utilisé au cours des 15 dernières années</div>
            <TextfieldAbattement
                type={"number"}
                placeholder={montant_utilise.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " €"}
            />
          </div>
          {donationsData.map((donation, index) => (
            <div key={index}>
              <div className="cardRow">
                <div style={styles.cardElemVerticalyCenter}>Indiquer la date de la donation antérieure {index + 1}</div>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DesktopDatePicker
                    inputFormat="DD/MM/YYYY"
                    value={donation.date}
                    onChange={(e) => {
                      void handleDonationChange(index, "date", parseInt(moment(e.toString()).utc(true).format("x")));
                    }}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
              </div>
              <div className="cardRow">
                <div style={styles.cardElemVerticalyCenter}>
                  Montant de la donation antérieure {index + 1} (au jour de la donation)
                </div>
                <TextfieldNumber
                  type={"number"}
                  placeholder={"Indiquer le montant"}
                  handleChange={handleDonationChange}
                  index={index}
                  keyName={"montant"}
                />
              </div>
              {isDroitsReglesEnabled() ? (
                <div className="cardRow">
                  <div style={styles.cardElemVerticalyCenter}>
                    Indiquer le montant des droits réglés pour la donation antérieure {index + 1}
                    <ToolTipPerso title={"Montant des droits de donation déjà payés pour cette donation antérieure"} />
                  </div>
                  <TextfieldNumber
                    type={"number"}
                    placeholder={"Indiquer le montant"}
                    handleChange={handleDonationChange}
                    index={index}
                    keyName={"droits_regles"}
                  />
                </div>
              ) : (
                <></>
              )}
            </div>
          ))}
          {isAbattementReconstitueEnabled() ? (
            <div className="cardRow">
              <div style={styles.cardElemVerticalyCenter}>
                Abattement reconstitué dans le rappel fiscal
                <ToolTipPerso title={"Dans le délai de rappel fiscal des donations antérieures qui est de 15 ans."} />
              </div>
              <TextfieldNumber type={"number"} placeholder={"Indiquer le montant"} handleChange={handleChange} setter={setAbattementReconstitue} max={abattement_legal} />
            </div>
          ) : null}
          <div>
            <div style={styles.buttonsArea}>
              <button style={styles.removeButton} type="button" onClick={() => removeDonation()}>
                Supprimer donation
              </button>
              <button style={styles.addButton} type="button" onClick={addDonation}>
                Ajouter donation
              </button>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}

      {parseInt(enRepresentation) === 1 && nombreRepresentants > 0 ? (
          <Souche
            donataires={representants}
            functionSetResults={FunctionSetRepresentantsList}
            FunctionSetAllRepresentantsList={FunctionSetAllRepresentantsList}
            simulateurid={props.simulateurid}
            montantRepresentant={montantRepresentant}
            abattementLegalRepresentant={abattementLegalRepresentant}
            lienParenteSuccession={lien_parente_succession}
          />
      ) : (
          <></>
      )}
    </div>
  );
};
export default Successions_Donataire;
